<div>
  <ng-container *ngIf="!isEditing">
    <span *ngIf="data" [innerHtml]="sanitizeHtml(data)"></span>
    <span *ngIf="!data">{{ placeholder }}</span>
    <i class="fa fa-edit" (click)="toggleEdit()"></i>
  </ng-container>
  <ng-container *ngIf="isEditing">
    <angular-editor
      class="m-2"
      id="editor"
      [editor]="editor"
      [(ngModel)]="data"
      [toolbar]="toolbar"
      placeholder="Enter text here..."
    ></angular-editor>

    <button (click)="saveEdit()" class="btn btn-primary m-2">
      {{ "Form.SAVE" | translate }}
    </button>
  </ng-container>
</div>
